import "./App.css";
import Trainer from "./articulation/Trainer";

// Single mode for now (Articulation Trainer). Structured so a sales-trainer
// mode can slot in beside it later behind a mode picker.
function App() {
  return <Trainer />;
}

export default App;
